'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSavedSearchItemsIfNeeded = exports.getSavedSearchItem = exports.isSavedSearchItemsLoading = exports.getSortedSavedSearchItemIds = exports.getSavedSearchItemIds = exports.LOAD_SAVED_SEARCH_ITEMS_SUCCESS = exports.LOAD_SAVED_SEARCH_ITEMS_REQUEST = exports.LOAD_SAVED_SEARCH_ITEMS_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _reselect = require('reselect');

var _user = require('../modules/user');

var _config = require('../modules/config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_SAVED_SEARCH_ITEMS_FAIL = exports.LOAD_SAVED_SEARCH_ITEMS_FAIL = 'la/user/savedSearchItem/LOAD_FAIL';
var LOAD_SAVED_SEARCH_ITEMS_REQUEST = exports.LOAD_SAVED_SEARCH_ITEMS_REQUEST = 'la/user/savedSearchItem/LOAD_REQUEST';
var LOAD_SAVED_SEARCH_ITEMS_SUCCESS = exports.LOAD_SAVED_SEARCH_ITEMS_SUCCESS = 'la/user/savedSearchItem/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    ids: [],
    loaded: 0,
    loading: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var byId = void 0;
    var ids = void 0;

    switch (action.type) {
        case LOAD_SAVED_SEARCH_ITEMS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_SAVED_SEARCH_ITEMS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_SAVED_SEARCH_ITEMS_SUCCESS:
            byId = {};
            ids = [];
            action.payload.forEach(function (x) {
                byId[x.itemId] = {
                    itemId: x.itemId,
                    publishDate: x.publishDate,
                    publishTs: Date.parse(x.publishDate) / 1000
                };
                ids.push(x.itemId);
            });
            return (0, _extends3.default)({}, state, {
                byId: byId,
                ids: ids,
                loaded: action.meta.actionTime,
                loading: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.savedSearchItem;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byISelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var getSavedSearchItemIds = exports.getSavedSearchItemIds = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.ids || [];
});

var getSortedSavedSearchItemIds = exports.getSortedSavedSearchItemIds = (0, _reselect.createSelector)(byISelector, function (byId) {
    var toBeSorted = (0, _keys2.default)(byId).map(function (x) {
        return byId[x];
    });
    var sorted = toBeSorted.sort(function (a, b) {
        return b.publishTs - a.publishTs;
    });
    return sorted.map(function (x) {
        return x.itemId;
    });
});

var getLoadTimeForSavedSearchItems = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded || 0;
});

var isSavedSearchItemsLoading = exports.isSavedSearchItemsLoading = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading || false;
});

var getSavedSearchItem = exports.getSavedSearchItem = (0, _reselect.createSelector)([byISelector, idSelector], function (byId, id) {
    return byId[id] || {
        itemId: id,
        publishTs: 0
    };
});

var shouldFetchSavedSearchItems = function shouldFetchSavedSearchItems(state) {
    var loaded = getLoadTimeForSavedSearchItems(state);
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME) return false;
    return !isSavedSearchItemsLoading(state);
};

/* ACTION CREATORS */
var fetchSavedSearchItemsIfNeeded = exports.fetchSavedSearchItemsIfNeeded = function fetchSavedSearchItemsIfNeeded() {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchSavedSearchItems(state)) {
                                _context.next = 15;
                                break;
                            }

                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            _context.prev = 4;

                            dispatch({
                                type: LOAD_SAVED_SEARCH_ITEMS_REQUEST
                            });
                            _context.next = 8;
                            return _api.SaveSearch.fetchSavedSearchItems({ authToken: authToken, deployment: deployment });

                        case 8:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_SAVED_SEARCH_ITEMS_SUCCESS
                            });
                            // start downloading the items
                            // const state2 = getState();
                            // const itemIds = getSavedSearchItemIds(state2);
                            // dispatch(fetchItemsIfNeeded(itemIds, 'saved-search-items'));
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](4);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: LOAD_SAVED_SEARCH_ITEMS_FAIL
                            });

                        case 15:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[4, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/savedSearchItem.js
// module id = c5lA
// module chunks = 46